import React from 'react';
import { WebsiteDesignProps } from './types';
import { ConciergeBell, Star, MapPin } from 'lucide-react';
import { Button } from "@/components/ui/button";

const LuxuryResort: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Royal Institute";

    return (
        <div className="bg-[#111111] text-[#d4af37] min-h-screen font-sans">
             <nav className="p-8 flex justify-between items-center border-b border-[#333]">
                 <div className="text-xl font-light uppercase tracking-[0.3em] text-white">
                     {schoolName}
                 </div>
                 <div className="flex gap-8 text-xs font-bold uppercase tracking-widest text-[#888]">
                     <a href="#" className="hover:text-[#d4af37] transition-colors">Concierge</a>
                     <a href="#" className="hover:text-[#d4af37] transition-colors">Amenities</a>
                     <a href="#" className="hover:text-[#d4af37] transition-colors">Booking</a>
                 </div>
             </nav>

             <main className="relative">
                 {/* Hero Image */}
                 <div className="h-[70vh] w-full relative overflow-hidden">
                     <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover opacity-60" alt="Resort" />
                     <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-transparent to-transparent"></div>
                     
                     <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
                         <div className="flex gap-2 text-[#d4af37] mb-6">
                             <Star size={16} fill="currentColor" />
                             <Star size={16} fill="currentColor" />
                             <Star size={16} fill="currentColor" />
                             <Star size={16} fill="currentColor" />
                             <Star size={16} fill="currentColor" />
                         </div>
                         <h1 className="text-5xl md:text-7xl font-light text-white mb-8 tracking-wide leading-tight uppercase">
                             Excellence <br/> <span className="font-serif italic text-[#d4af37] lowercase">redefined</span>
                         </h1>
                         <Button className="bg-[#d4af37] text-black hover:bg-white hover:text-black rounded-none px-10 py-6 uppercase tracking-widest text-xs font-bold transition-all">
                             Reserve Your Place
                         </Button>
                     </div>
                 </div>

                 <div className="container mx-auto px-8 py-20 -mt-20 relative z-10 grid grid-cols-1 md:grid-cols-3 gap-8">
                     {[
                         { title: "World Class", desc: "Amenities and facilities unmatched globally." },
                         { title: "Privacy", desc: "Exclusive focus and personalized attention." },
                         { title: "Service", desc: "Educational support available 24/7." }
                     ].map((item, i) => (
                         <div key={i} className="bg-[#1a1a1a] p-10 border border-[#333] hover:border-[#d4af37] transition-colors text-center group">
                             <h3 className="text-xl font-serif italic text-white mb-4 group-hover:text-[#d4af37] transition-colors">{item.title}</h3>
                             <p className="text-[#666] text-sm leading-relaxed uppercase tracking-wide">{item.desc}</p>
                         </div>
                     ))}
                 </div>

                 <div className="text-center pb-20 text-[#444] text-xs uppercase tracking-[0.3em]">
                     <MapPin size={12} className="inline mb-1 mr-2" /> 
                     100 Learning Ave, Beverly Hills, CA
                 </div>
            </main>
        </div>
    );
};

export default LuxuryResort;
